export function applySelectionDiff(
  current: Set<string>,
  next: Set<string>,
  onToggle: (id: string) => void,
): void {
  for (const id of next) {
    if (!current.has(id)) onToggle(id);
  }
  for (const id of current) {
    if (!next.has(id)) onToggle(id);
  }
}
